import { useTranslation } from 'react-i18next';
import type { UserAccessRoleType } from '@econtractor/types';

const ROLE_CLASS: Record<UserAccessRoleType, string> = {
    manager: 'bg-primary',
    seller: 'bg-info',
    executor: 'bg-warning text-dark',
};

const ROLE_LABEL: Record<UserAccessRoleType, string> = {
    manager: 'Users.roles.manager',
    executor: 'Users.roles.executor',
    seller: 'Users.roles.seller',
};

interface UserRoleBadgeProps {
    role?: string | null;
    className?: string;
}

const isUserRole = (role?: string | null): role is UserAccessRoleType =>
    role === 'manager' || role === 'executor' || role === 'seller';

const UserRoleBadge = ({ role, className = '' }: UserRoleBadgeProps) => {
    const { t } = useTranslation();
    if (!isUserRole(role)) return null;

    return (
        <span className={`badge ${ROLE_CLASS[role]} ${className}`.trim()}>
            {t(ROLE_LABEL[role])}
        </span>
    );
};

export default UserRoleBadge;
